import { notification } from 'antd'
import apiClient from '../index'

export const getEmpPunchLogs = async () => {
  try {
    const response = await apiClient.get('punchLogs/biometric/punchlogs')
    return response?.data
  } catch (error) {
    notification.error({
      message: error?.response?.data?.message || error?.message || 'Failed to fetch punch logs',
    })
    return null
  }
}

export const getEmpCalendarPunches = async () => {
  try {
    const response = await apiClient.get('/punchLogs/biometric/cal/punches')
    return response?.data
  } catch (error) {
    notification.error({
      message: error?.response?.data?.message || error?.message || 'Failed to fetch punch logs',
    })
    return null
  }
}

export const getEmpPunchReport = async (month, year, selectedEmployeeId, skip = 0, limit = 10) => {
  try {
    const params = {}

    if (month) params.month = month
    if (year) params.year = year
    if (selectedEmployeeId) params.employeeId = selectedEmployeeId

    params.skip = skip
    params.limit = limit

    const response = await apiClient.get('/punchLogs/biometric/employee/punch-report', { params })

    return response?.data
  } catch (error) {
    notification.error({
      message:
        error?.response?.data?.message ||
        error?.message ||
        'Failed to fetch employee punching report',
    })
    return null
  }
}
